import { ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'ngx-webstorage';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { loginComponent } from '../../modules/user/auth/login/login.component';
import { signupComponent } from '../../modules/user/auth/signup/signup.component';
import { AuthService } from '../../services/auth.service';
import { CartService } from '../../services/cart.service';
import { AddressBookService } from '../../services/address.service';
import { ConfigurationService } from '../../services/config.service';
import { EditOrderSaveChangesComponent } from '../../modules/orders/edit/save-changes/save-changes.component';
var headerComponent = /** @class */ (function () {
    function headerComponent(modalService, configAPI, eRef, authAPIs, cartService, localSt, _location, router, activeRoute, addressAPIs) {
        var _this = this;
        this.modalService = modalService;
        this.configAPI = configAPI;
        this.eRef = eRef;
        this.authAPIs = authAPIs;
        this.cartService = cartService;
        this.localSt = localSt;
        this._location = _location;
        this.router = router;
        this.activeRoute = activeRoute;
        this.addressAPIs = addressAPIs;
        this.isLoggedIn = false;
        this.showDropDown = false;
        this.clearSearch = false;
        this.showMenuDropDown = false;
        this.showMenuBigDevice = false;
        this.homeContentRefreshFlag = false;
        this.userName = '';
        this.showSearchBar = false;
        this.totalCartItems = 0;
        this.showMyCart = false;
        this.cartItems = [];
        this.disableCartIcon = false;
        this.editOrderAddingAnotherItem = false;
        this.showLoginSignupDropDown = false;
        router.events.subscribe(function (route) {
            if (route instanceof NavigationEnd) {
                route.url === '/checkout/review-order' && route.url ? _this.disableCartIcon = true : _this.disableCartIcon = false;
            }
        });
    }
    headerComponent.prototype.clickOut = function (event) {
        if (this.eRef.nativeElement.contains(event.target)) {
        }
        else {
            this.showDropDown = false;
            this.showMenuDropDown = false;
        }
    };
    headerComponent.prototype.onScrollEvent = function ($event) {
        if ($event.path[1].scrollY > 0) {
            this.showDropDown = false;
            this.showMenuDropDown = false;
            this.showLoginSignupDropDown = false;
        }
    };
    headerComponent.prototype.onResize = function () {
        if (this.parentDiv) {
            this.divWidth = this.parentDiv.nativeElement.clientWidth;
        }
        this.reSIzeCalander();
    };
    headerComponent.prototype.reSIzeCalander = function () {
        window.innerWidth > 1000 ? this.showMenuBigDevice = true : this.showMenuBigDevice = false;
        if (window.innerWidth > 600) {
            this.localSt.store('widthGreater600', true);
        }
        else {
            this.localSt.store('widthGreater600', false);
        }
    };
    headerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getSmartKey();
        // TODO Need to move this code in separate CartIcon Component
        // this.iconCountSubcriber = this.localSt.observe('totalCartItems').subscribe((data) => {
        //   console.log('inside CartIcon', data)
        //   if (data) {
        //     this.totalCartItems = data;
        //   }
        // });
        // this.iconCountSubcriber = this.cartService.totalCountStreem$
        //    .subscribe(totalNumber => this.totalCartItems = totalNumber);
        this.searchForm = new FormGroup({ searchItems: new FormControl() });
        // CartIcon update Number
        if (this.localSt.retrieve('cartItems')) {
            this.cartItems = this.localSt.retrieve('cartItems');
            this.cartItems.forEach(function (dateObj) {
                // this.totalCartItems = this.totalCartItems + dateObj.items.length;
                dateObj.items.forEach(function (item) {
                    _this.totalCartItems = _this.totalCartItems + item.count;
                });
            });
        }
        this.localSt.observe('cartItems').subscribe(function (items) {
            _this.totalCartItems = 0;
            _this.cartItems = items;
            _this.cartItems.forEach(function (dateObj) {
                // this.totalCartItems = this.totalCartItems + dateObj.items.length;
                dateObj.items.forEach(function (item) {
                    _this.totalCartItems = _this.totalCartItems + item.count;
                });
            });
        });
        // CartIcon update Number
        this.localSt.observe('hideSearchBar').subscribe(function (hideSearchBar) {
            if (hideSearchBar) {
                _this.showSearchBar = false;
                _this.searchForm.controls.searchItems.setValue('');
                _this.clearSearch = false;
            }
        });
        if (this.localSt.retrieve('zenUser')) {
            this.isLoggedIn = true;
            this.showLoginSignupDropDown = false;
            this.userName = this.localSt.retrieve('zenUser').zf_first_name + ' ' + this.localSt.retrieve('zenUser').zf_last_name;
        }
        this.localSt.observe('zenUser').subscribe(function (data) {
            if (data) {
                _this.showLoginSignupDropDown = false;
                _this.userName = data.zf_first_name + ' ' + data.zf_last_name;
                _this.isLoggedIn = true;
            }
            else {
                _this.isLoggedIn = false;
            }
        });
        setTimeout(function (_) {
            _this.divWidth = _this.parentDiv.nativeElement.clientWidth;
            _this.reSIzeCalander();
        });
        this.showMyCart = this.localSt.retrieve('showMyCart');
        this.localSt.observe('showMyCart').subscribe(function (res) {
            _this.showMyCart = res;
        });
        if (this.localSt.retrieve('zenUser')) {
            this.defaultAddressZipCode();
        }
        // tslint:disable-next-line:max-line-length
        this.localSt.retrieve('editOrderAddingAnotherItem') ? this.editOrderAddingAnotherItem = this.localSt.retrieve('editOrderAddingAnotherItem') : this.editOrderAddingAnotherItem = false;
        setTimeout(function (_) {
            _this.localSt.observe('editOrderAddingAnotherItem').subscribe(function (editOrderAddingAnotherItem) {
                _this.editOrderAddingAnotherItem = !!editOrderAddingAnotherItem;
            });
        });
    };
    headerComponent.prototype.loginModal = function () {
        this.modalService.open(loginComponent, { backdrop: 'static', keyboard: false });
    };
    headerComponent.prototype.signupModal = function () {
        this.modalService.open(signupComponent, { backdrop: 'static', keyboard: false });
    };
    headerComponent.prototype.showHideDropDown = function () {
        this.showDropDown = !this.showDropDown;
    };
    headerComponent.prototype.logOutClick = function () {
        var _this = this;
        this.showDropDown = false;
        if (this.localSt.retrieve('orderEditingMore')) {
            this.modalService.open(EditOrderSaveChangesComponent, { backdrop: 'static', keyboard: false }).result.then(function (response) {
                if (response) {
                    _this.localSt.clear('editOrderItems');
                    _this.localSt.clear('orderEditingMore');
                    _this.localSt.clear('editOrderAddress');
                    _this.authAPIs.logOut().subscribe(function () {
                        _this.localSt.clear('zenUser');
                        _this.router.navigate(['/']);
                        if (_this.localSt.retrieve('appliedPromo') && !_this.localSt.retrieve('appliedPromo').multipleUsage) {
                            _this.localSt.clear('appliedPromo');
                        }
                        if (_this.localSt.retrieve('validZipCode')) {
                            _this.localSt.clear('validZipCode');
                        }
                    });
                }
            });
        }
        else {
            this.authAPIs.logOut().subscribe(function () {
                _this.localSt.clear('zenUser');
                _this.router.navigate(['/']);
                if (_this.localSt.retrieve('appliedPromo') && !_this.localSt.retrieve('appliedPromo').multipleUsage) {
                    _this.localSt.clear('appliedPromo');
                }
                if (_this.localSt.retrieve('validZipCode')) {
                    _this.localSt.clear('validZipCode');
                }
            });
        }
    };
    headerComponent.prototype.onChange = function (value) {
        this.localSt.store('serachBoxValue', value);
        this.clearSearch = true;
        if (value === '') {
            this.clearSearchField();
        }
    };
    headerComponent.prototype.homeContentRefresh = function () {
        this.localSt.store('homeRefresh', this.homeContentRefreshFlag = !this.homeContentRefreshFlag);
    };
    headerComponent.prototype.openMyCardClick = function () {
        this.localSt.store('showMyCart', this.showMyCart = !this.showMyCart);
    };
    headerComponent.prototype.canDeactivate = function () {
        this.showSearchBar = false;
        return true;
    };
    headerComponent.prototype.clearSearchField = function () {
        this.searchForm.controls.searchItems.setValue('');
        this.clearSearch = false;
        this.localSt.store('serachBoxValue', '');
    };
    headerComponent.prototype.showSearch = function () {
        var _this = this;
        this.showSearchBar = true;
        setTimeout(function () {
            _this.inputElement.nativeElement.focus();
        }, 0);
    };
    headerComponent.prototype.cancelSearch = function () {
        this.showSearchBar = false;
        this.searchForm.controls.searchItems.setValue('');
        this._location.back();
        this.localSt.store('searchCancelFlag', true);
    };
    headerComponent.prototype.closeMyCart = function () {
        this.localSt.store('showMyCart', false);
    };
    headerComponent.prototype.defaultAddressZipCode = function () {
        var _this = this;
        this.addressAPIs.addressBookList().subscribe(function (res) {
            res.data.forEach(function (address) {
                if (address.zf_is_default) {
                    _this.localSt.store('validZipCode', address.zf_zip_code);
                    _this.localSt.store('checkoutDeliveryAddress', {
                        address_line1: address.zf_zip_code.zf_address_line_1,
                        address_line2: address.zf_zip_code.zf_address_line_2,
                        address_state: address.zf_zip_code.zf_state,
                        address_city: address.zf_zip_code.zf_city,
                        address_zip: address.zf_zip_code.zf_zip_code
                    });
                }
            });
        });
    };
    headerComponent.prototype.getSmartKey = function () {
        var _this = this;
        this.configAPI.getConfigurations().subscribe(function (res) {
            _this.smartKey = res.data;
            var phoneCharArr = _this.smartKey.zf_phone_number.split('');
            var phoneNo = '(';
            for (var i = 0; i < phoneCharArr.length; i++) {
                phoneNo = phoneNo + phoneCharArr[i];
                if (i === 2) {
                    phoneNo = phoneNo + ') ';
                }
                else if (i === 5) {
                    phoneNo = phoneNo + '-';
                }
            }
            _this.localSt.store('supportEmailPhone', { phone: phoneNo, email: _this.smartKey.zf_email });
            _this.localSt.store('taxPercentage', _this.smartKey.zf_tax_percentage);
            _this.localSt.store('smartyStreetKey', _this.smartKey.zf_smarty_street_configs ? _this.smartKey.zf_smarty_street_configs.zf_smarty_streets_key : null);
            _this.localSt.store('zipCodes', _this.smartKey.zf_zip_codes);
            _this.localSt.store('stripePK', _this.smartKey.zf_stripe_public_key);
            // this.localSt.store('stripePK', 'pk_live_U5eRwGmdwY1jbtHEtVR8v4xe');
        });
    };
    headerComponent.prototype.logoClick = function () {
        var _this = this;
        if (this.localSt.retrieve('orderEditingMore')) {
            this.modalService.open(EditOrderSaveChangesComponent, { backdrop: 'static', keyboard: false }).result.then(function (response) {
                if (response) {
                    _this.localSt.clear('editOrderItems');
                    _this.localSt.clear('orderEditingMore');
                    _this.localSt.clear('editOrderAddress');
                    window.open('http://zenclassics.com', '_self');
                }
            });
        }
        else {
            window.open('http://zenclassics.com', '_self');
        }
    };
    return headerComponent;
}());
export { headerComponent };



// WEBPACK FOOTER //
// ./src/app/template/header/header.component.ts.pre-build-optimizer.js